import cx from 'classnames'

import { ReactComponent as ImageLinkIcon } from '../icons/link.svg'
import { ReactComponent as ImageUploadIcon } from '../icons/upload.svg'
import { Upload } from 'blaze-ui/icons/20/Upload'
import Styles from '../Prompt.module.scss'
import {
  Integration,
  AddImageFromLink,
  UploadMedia,
  Unsplash,
  Giphy,
  UploadsLibrary,
} from 'proseShared/IntegrationsIcons'
import { ReactComponent as GiphyIcon } from 'assets/icons/logos/giphy24.svg'
import { ReactComponent as UnsplashIcon } from 'assets/icons/logos/unsplash24.svg'
import { Provider } from 'components/ImagePickerModal/Types'

export interface Props {
  activeIntegration: Integration
  setActiveIntegration: (integration: Integration) => void
  hiddenProviders?: Set<Provider>
}

const Sidebar = ({ activeIntegration, setActiveIntegration, hiddenProviders }: Props) => {
  const renderIcon = (integration: Integration) => {
    switch (integration) {
      case AddImageFromLink:
        return <ImageLinkIcon />
      case UploadMedia:
        return <ImageUploadIcon />
      case Unsplash:
        return <UnsplashIcon />
      case Giphy:
        return <GiphyIcon />
      case UploadsLibrary:
        return <Upload />
      default:
        break
    }
  }

  const renderIntegration = (integration: Integration) => {
    const elementId = integration.name.split(' ').join('')
    return (
      <li
        key={integration.name}
        id={elementId}
        onClick={() => setActiveIntegration(integration)}
        className={cx({
          [Styles.activeAction]: integration === activeIntegration,
          [Styles.disabledAction]: !integration.enabled,
        })}
      >
        {renderIcon(integration)}
        {integration.name}
        {!integration.enabled && <span>(Coming soon)</span>}
      </li>
    )
  }

  return (
    <div className={Styles.mediaUploadSidebar}>
      <p>Add Photos</p>
      <ul>
        {!hiddenProviders?.has('link') && renderIntegration(AddImageFromLink)}
        {!hiddenProviders?.has('uploads') && renderIntegration(UploadMedia)}
        {!hiddenProviders?.has('uploads') && renderIntegration(UploadsLibrary)}
      </ul>

      <p>Apps</p>
      <ul>
        {!hiddenProviders?.has('stock') && renderIntegration(Unsplash)}
        {!hiddenProviders?.has('gifs') && renderIntegration(Giphy)}
      </ul>
    </div>
  )
}

export default Sidebar
